import React from 'react';
import Panel from '../../../CommonComponents/Panel/Panel';
import PanelGroup from '../../../CommonComponents/Panel/PanelGroup';
import DeliveryOptions from './../../components/DeliveryOptions/DeliveryOptions';
import './PDPAccordian.scss';
import TechInfoData from './TechInfoData';
import { connect } from 'react-redux';
import {
  getProductReviewListLoad,
  getProductReviewListReset,
} from '../../../actionCreators/review';
import BlankLoader from '../BlankLoader/BlankLoader';
import Review from './Review/Review';

class PDPAccordian extends React.Component {
  componentDidMount() {
    const { getProductReviewListLoad, productData, reviewPageSize } = this.props;
    const { id } = productData;
    getProductReviewListLoad({ productId: id, page: 1, pageCount: reviewPageSize });
  }

  componentWillUnmount() {
    const { getProductReviewListReset } = this.props;
    getProductReviewListReset();
  }

  moreWriteButton(reviews) {
    const {
      showReview,
      dataLocale: { WRITE_A_REVIEW, MORE_REVIEWS },
    } = this.props;
    return (
      <div className="reivew-button display-flex">
        {reviews?.length > 1 && (
          <button className="btn btn-mr-review text-uppercase" onClick={() => showReview(false)}>
            {MORE_REVIEWS}
          </button>
        )}
        <button
          className={`btn btn-main text-uppercase ${reviews?.length > 1 ? ' margin-l15' : ''}`}
          onClick={() => showReview(true)}
        >
          {WRITE_A_REVIEW}
        </button>
      </div>
    );
  }

  reviewDom(reviews) {
    const {
      dataLocale: { NO_REVIEWS },
    } = this.props;
    if (reviews && reviews.length > 0) {
      const review = reviews[0];
      const { reviewId, reviewTitle, reviewDetail, reviewee, reviewDate, noOfStars, images } =
        review;
      return (
        <>
          <Review
            key={reviewId}
            className="padding-b25"
            images={images}
            noOfStars={noOfStars}
            reviewDate={reviewDate}
            reviewDetail={reviewDetail}
            reviewId={reviewId}
            reviewTitle={reviewTitle}
            reviewee={reviewee}
            startId={`${reviewId}-0`}
          />
          {this.moreWriteButton(reviews)}
        </>
      );
    }
    return (
      <>
        <div className="text-center margin-b10">{NO_REVIEWS}</div>
        {this.moreWriteButton(reviews)}
      </>
    );
  }

  render() {
    const {
      localeInfo,
      dataLocale,
      productData,
      cmsPopUpData,
      getCmsPageData,
      isReviewListLoading,
      productReviewList,
    } = this.props;
    const {
      STORE_LOCATOR,
      SHARE_YOUR_LOCATION_TEXT,
      VISIT_NEARBY_STORE,
      TECHNICAL_INFORMATION,
      CHECK_DELIVERY_OPTIONS,
      REVIEW,
      STORE_LOCATION,
    } = dataLocale || {};
    return (
      <div className="product-accordian margin-t40">
        {/* refernce for this panel accordion https://react-bootstrap-v3.netlify.app/components/panel/ */}
        <PanelGroup accordion="true" defaultActiveKey="4" id="accordion-uncontrolled-example">
          <Panel aria-label="panel" className="accordian-tab" eventKey="1">
            <Panel.Heading className="accordian-tab-heading">
              <Panel.Title toggle className="fs14 fw700 accordian-tab-title">
                {TECHNICAL_INFORMATION}
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible className="padding-l0 padding-r0">
              <TechInfoData
                cmsPopUpData={cmsPopUpData}
                dataLocale={dataLocale}
                getCmsPageData={getCmsPageData}
                localeInfo={localeInfo}
                productData={productData}
              />
            </Panel.Body>
          </Panel>
          {localeInfo.countryCode === 'in' && (
            <Panel className="accordian-tab" eventKey="2">
              <Panel.Heading className="accordian-tab-heading">
                <Panel.Title toggle className="fs14 fw700 accordian-tab-title">
                  {VISIT_NEARBY_STORE}
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible className="padding-l0 padding-r0">
                <div className="display-flex">
                  <div className="w-135">
                    <img
                      alt={STORE_LOCATION}
                      className="bora-4"
                      src="https://static.lenskart.com/media/desktop/img/pdp/visit_store.png"
                    />
                  </div>
                  <div className="padding-l20">
                    <span className="share-location-description">{SHARE_YOUR_LOCATION_TEXT}</span>
                    <div className="store-locator-btn padding-t5">
                      <a
                        aria-label="store locator"
                        className="fs13 no-decoration"
                        href="https://www.lenskart.com/optical-store"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {STORE_LOCATOR}
                      </a>
                    </div>
                  </div>
                </div>
              </Panel.Body>
            </Panel>
          )}
          {localeInfo.countryCode === 'in' && (
            <Panel className="accordian-tab" eventKey="3">
              <Panel.Heading className="accordian-tab-heading">
                <Panel.Title toggle className="fs14 fw700 accordian-tab-title">
                  {CHECK_DELIVERY_OPTIONS}
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                <DeliveryOptions pdpCheckDeliveryCustom productData={productData} />
              </Panel.Body>
            </Panel>
          )}
          <Panel className="accordian-tab" eventKey="4">
            <Panel.Heading className="accordian-tab-heading">
              <Panel.Title toggle className="fs14 fw700 accordian-tab-title">
                {REVIEW}({productReviewList?.result?.numberOfReviews || 0})
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible className="padding-l0 padding-r0">
              {isReviewListLoading && !productReviewList?.result?.review?.reviews ? (
                <BlankLoader />
              ) : (
                this.reviewDom(productReviewList?.result?.review?.reviews)
              )}
            </Panel.Body>
          </Panel>
        </PanelGroup>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isReviewListLoading: state.review.isReviewListLoading,
  productReviewList: state.review.productReviewList,
  reviewPageSize: state.review.reviewPageSize,
  dataLocale: state.locale,
  localeInfo: state.common.localeInfo,
});

const mapDispatchToProps = dispatch => {
  return {
    getProductReviewListLoad: data => dispatch(getProductReviewListLoad(data)),
    getProductReviewListReset: () => dispatch(getProductReviewListReset()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PDPAccordian);
